import { render, staticRenderFns } from "./Lightbox.vue?vue&type=template&id=c2a24c44&scoped=true"
import script from "./Lightbox.vue?vue&type=script&lang=ts"
export * from "./Lightbox.vue?vue&type=script&lang=ts"
import style0 from "./Lightbox.vue?vue&type=style&index=0&id=c2a24c44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a24c44",
  null
  
)

export default component.exports